import React from 'react';
import { Box, Typography } from '@mui/material';

const LoadingOverlay = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3
        }}
      >
        <img
          src="/white_logo_transparent.png"
          alt="Weldingo"
          style={{
            width: '160px',
            height: '160px',
            animation: 'spin 2s linear infinite'
          }}
        />
        <Typography variant="h6" color="white" sx={{ textAlign: 'center' }}>
          Loading...
        </Typography>
      </Box>
      <style>
        {`
          @keyframes spin {
            from { transform: rotateY(0deg); }
            to { transform: rotateY(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default LoadingOverlay;